import React from 'react';

const ShopIllustration = props => (
  <img src="https://d2o5po5b88zacb.cloudfront.net/dist/assets/lshash-9919532/images/first-start/shop-illustration.svg" alt="" {...props} />
);

export default ShopIllustration;
